import React from "react";
import Box from "@mui/material/Box";
import { Grid, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import styled from "styled-components";

const DescriptionContainer = (props) => {
  const { brand = "", description = "", price = {},title } = props;
  const { price: itemPrice = 0, discountedPrice = 0 } = price;

  const discount = Math.floor(
    ((Number(itemPrice) - Number(discountedPrice)) / Number(itemPrice)) * 100
  );

  console.log("props areeeeeeeeeeeeee",props);

  const WishlistDetails = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0rem 1rem;
  font-size: 14px;
  text-align: left;
  margin-right:auto;

  .wishlist-brand {
    font-weight: 400;
    font-size: 15px;
    color:rgb(120, 120, 120);
    font-family: "Ancizar Sans", sans-serif;
  }

  .wishlist-title {
font-weight: 400;
    font-size: 17px;
    margin-bottom: .23rem;
    font-family: "Ancizar Sans", sans-serif;
    max-width: 300px;
    line-height: 1;
  }

  .wishlist-pricem {
display: flex;
justify-content:center;
align-items:center;
}

  .wishlist-price {
    font-weight: 400;
    font-size: 17px;
    text-decoration:line-through;
    margin-bottom: .23rem;
    font-family: "Ancizar Sans", sans-serif;
    margin: 0rem .1rem;

  }

  .wishlist-discount {
    font-weight: 500;
    font-size: 17px;
   
    
    margin-bottom: .23rem;
    font-family: "Ancizar Sans", sans-serif;
    margin: 0rem .1rem;
     margin-right:.5rem;
    color:rgb(44, 105, 0);
  }



  
  `

  return (
    <React.Fragment>
      <Box display={"flex"}>
        <WishlistDetails>
           <div className="wishlist-brand">
            {brand}
           </div>
           <div className="wishlist-title">
            {title}
           </div>
            <div className="wishlist-pricem">
              <p className="wishlist-discount">₹ {discountedPrice}</p>  <p className="wishlist-price">₹ {itemPrice}</p>
            </div>
        </WishlistDetails>
      </Box>
    </React.Fragment>
  );
};

export default DescriptionContainer;
